import React from "react";

function DebugTools({ setUserLat, setUserLng, setHeading, userLat, userLng }) {
  return (
    <div className="fixed left-4 bottom-4 z-[1000] flex flex-col gap-2">
      <button
        className="px-4 py-2 rounded-lg border border-amber-700 bg-[#181c23] text-amber-200 font-semibold cursor-pointer shadow-lg hover:bg-amber-800/80 hover:text-white transition-colors"
        onClick={() => {
          setUserLat((lat) => (lat !== null ? lat + 0.0005 : 22.3193 + 0.0005));
          setUserLng((lng) =>
            lng !== null ? lng + 0.0005 : 114.1694 + 0.0005
          );
        }}
      >
        模擬移動
      </button>
      <button
        className="px-4 py-2 rounded-lg border border-amber-700 bg-[#181c23] text-amber-200 font-semibold cursor-pointer shadow-lg hover:bg-amber-800/80 hover:text-white transition-colors"
        onClick={() => {
          setHeading((h) => (h + 30) % 360);
        }}
      >
        模擬旋轉
      </button>
    </div>
  );
}

export default DebugTools;
